import { render } from "./CodingTestCaseEditor.vue?vue&type=template&id=570d0538&scoped=true"
import script from "./CodingTestCaseEditor.vue?vue&type=script&lang=js"
export * from "./CodingTestCaseEditor.vue?vue&type=script&lang=js"

import "./CodingTestCaseEditor.vue?vue&type=style&index=0&id=570d0538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570d0538"]])

export default __exports__